const s3SkillsLabels = {
    fr: {
        r1: "Comprendre son organisation",
        r2: "Comprendre les besoins d'autrui",
        r3: "Résoudre un problème complexe",
        r4: "Esprit critique",
        r5: "Créer des solutions innovantes",
        r6: "Construire une vision personnelle pour son activité",
        r7: "Identifier des personnes ressources",
        r8: "Coopérer",
        r9: "Se connaitre ",
        r10: "Prendre des risques",
        r11: "S’engager durablement pour l’entreprise",
        r12: "Gérer son stress",
        r13: "Promouvoir",
        r14: "Motiver un collectif",
        r15: "Contribuer à un travail collectif",
        r16: "Organiser le travail d'un collectif",
        r17: "Orienter le travail d'un collectif"
    },
    en: {
        r1: "Understand an organization",
        r2: "Understand the needs of others",
        r3: "Solve a complex problem",
        r4: "Critical thinking",
        r5: "Create innovative solutions",
        r6: "Build a personal vision",
        r7: "Find resource people",
        r8: "Cooperate",
        r9: "Self awareness",
        r10: "Risk-taking",
        r11: "Sustainable involvement",
        r12: "Manage stress",
        r13: "Promote",
        r14: "Motivate a group",
        r15: "Contribute to group tasks",
        r16: "Organize a group",
        r17: "Lead a group"
    }
}
export default s3SkillsLabels
